import 'css-chunksrc/client/common/filterMenu/projectStatuses/projectStatus/styles.scss';export default {
  "project": "_project_163ih_1",
  "icon": "_icon_163ih_11",
  "name": "_name_163ih_19"
};